import pako from 'pako'

export function compress (plainText) {
  const textBuffer = new TextEncoder().encode(plainText)
  return pako.gzip(textBuffer)
}

export function decompress (compressedData) {
  const decompressedBuffer = pako.ungzip(compressedData)
  return new TextDecoder().decode(decompressedBuffer)
}
